import React from 'react';
import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import keys from 'lodash/keys';
import { PRODUCT_CLASS_CAMPAIGN, PRODUCT_CLASS_LANGUAGE_LEARNING, PRODUCT_CLASS_LOTE } from '../../store/constants';

const FILTER_STATE_INCLUDE_KEY = 'include';
const FILTER_STATE_EXCLUDE_KEY = 'exclude';

const FILTER_STATE_KEYS = [FILTER_STATE_INCLUDE_KEY, FILTER_STATE_EXCLUDE_KEY];
export default class CommonUtils {
    static convertStringToNumber(value, offset = 0) {
        if (/^([-+])?([0-9]+|Infinity)$/.test(value)) return Number(value) - offset;
        return 0;
    }

    static pushOrCreateArrayInObject(obj, key, item) {
        if (isArray(obj[key])) {
            obj[key].push(item);
        } else {
            obj[key] = [item];
        }
    }

    static parseFilter(filters) {
        if (!isPlainObject(filters)) return {};
        const reducedFilter = {};
        keys(filters).forEach(filterKey => {
            const filter = filters[filterKey];

            let buckets = [];
            let searchBuckets = [];

            if (isPlainObject(filter)) {
                buckets = filter.buckets ? filter.buckets : [];
                searchBuckets = filter.searchBuckets ? filter.searchBuckets : [];
            }

            if (!buckets.length && !searchBuckets.length) {
                return false;
            }
            let filterChanged = false;
            const filterEntry = [...buckets, ...searchBuckets].reduce((reducedFilter, bucket) => {
                const subBuckets = bucket.buckets || [];
                const subSearchBuckets = bucket.searchBuckets || [];

                if (subBuckets.length > 0 || subSearchBuckets.length > 0) {
                    [...subBuckets, ...subSearchBuckets]
                        .filter(subBucket => FILTER_STATE_KEYS.includes(subBucket.state))
                        .forEach(subBucket => {
                            const filterKeyAlreadyIncluded =
                                reducedFilter[subBucket.state] &&
                                reducedFilter[subBucket.state].includes(subBucket.key);
                            if (!filterKeyAlreadyIncluded) {
                                filterChanged = true;
                                CommonUtils.pushOrCreateArrayInObject(reducedFilter, subBucket.state, subBucket.key);
                            }
                        });
                }
                const filterKeyAlreadyIncluded =
                    reducedFilter[bucket.state] && reducedFilter[bucket.state].includes(bucket.key);

                if (FILTER_STATE_KEYS.includes(bucket.state) && !filterKeyAlreadyIncluded) {
                    filterChanged = true;
                    CommonUtils.pushOrCreateArrayInObject(reducedFilter, bucket.state, bucket.key);
                }
                return reducedFilter;
            }, {});

            if (filterChanged) {
                reducedFilter[filterKey] = filterEntry;
            }
        });
        return reducedFilter;
    }

    static joinComponents(elements, separator) {
        return elements.map((element, idx) => {
            if (idx !== elements.length - 1) {
                return [element, separator];
            } else {
                return element;
            }
        });
    }

    static safeJoinComponents(elements, separator, tag) {
        if (elements === null || elements === undefined || elements.length === 0) {
            return null;
        }
        if (elements.length === 1) {
            return elements[0];
        }

        return elements.reduce((result, cur, currentIndex) => [
            result,
            tag ? React.createElement(tag, { key: currentIndex }, separator) : separator,
            cur
        ]);
    }

    // Compares two values. Nulls are last.
    static cmp(a, b) {
        if (!a && !b) return 0;
        if (!a) return 1;
        if (!b) return -1;
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
    }

    static isForeignLanguageClass(value) {
        return (
            value &&
            [PRODUCT_CLASS_LOTE, PRODUCT_CLASS_LANGUAGE_LEARNING]
                .map(format => format.toLowerCase())
                .includes(value.toLowerCase())
        );
    }

    static isCampaignClass(value) {
        return value && [PRODUCT_CLASS_CAMPAIGN].map(format => format.toLowerCase()).includes(value.toLowerCase());
    }
}
